import React, { useState, useEffect, useRef } from 'react';
import { saveUserNote } from '../../api/notes';
import pb from '../../pocketbase';
import { applyGender, getCachedGender } from '../../utils/genderUtils';
import '../GamePlayOverlay/GamePlayOverlay.css';

export default function DailyNoteWritingOverlay({ gameId, card, onClose, onSave }) {
    const [noteText, setNoteText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const textareaRef = useRef(null);

    // Фокус на поле ввода при открытии
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
        }
    }, []);

    const handleSave = async () => {
        if (!noteText.trim()) return;

        setIsLoading(true);
        try {
            await saveUserNote(gameId, card.id, noteText.trim());
            if (onSave) {
                onSave(noteText.trim());
            }
            onClose();
        } catch (error) {
            console.error('Error saving note:', error);
            alert('Не удалось сохранить заметку. Попробуйте еще раз.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
            e.preventDefault();
            handleSave();
        }
    };

    // Функция для подтверждения закрытия заметки с черновиком
    const confirmCloseNote = () => {
        if (noteText.trim()) {
            // Если есть текст в заметке, показываем диалог подтверждения
            setShowConfirmDialog(true);
        } else {
            // Если заметка пустая, закрываем без подтверждения
            onClose();
        }
    };

    // Функция для подтверждения удаления черновика
    const handleConfirmDelete = () => {
        setShowConfirmDialog(false);
        onClose();
    };

    // Функция для отмены удаления черновика
    const handleCancelDelete = () => {
        setShowConfirmDialog(false);
    };

    // Формируем URL картинки используя PocketBase формат
    const coverUrl = card.image
        ? `${pb.baseUrl}/api/files/cards/${card.id}/${card.image_thumb || card.image}`
        : null;

    return (
        <>
            <div className="overlay overlay--gameplay overlay--note-writing" style={{ zIndex: 2000 }}>
                {/* Фон */}
                <div
                    className="overlay-bg overlay-bg--current"
                    style={{
                        backgroundImage: coverUrl ? `url(${coverUrl})` : 'none',
                        opacity: 0.4
                    }}
                />

                {/* Хедер с кнопками */}
                <div className="upper-button-wrap">
                    <div className="upper-buttons">
                        <button className="btn-40" onClick={confirmCloseNote}>
                            <img src="/icons/close.svg" alt="Закрыть" />
                        </button>

                        <div className="progress-badge">
                            Новая заметка
                        </div>

                        <button
                            className={`btn-40 ${noteText.trim() ? 'btn-40--active' : ''}`}
                            onClick={handleSave}
                            disabled={!noteText.trim() || isLoading}
                        >
                            {isLoading ? (
                                <div className="loading-spinner-small" />
                            ) : (
                                <img src="/icons/checkmark.svg" alt="Сохранить" />
                            )}
                        </button>
                    </div>
                </div>

                {/* Контент */}
                <div className="note-writing-content">
                    {/* Карточка вопроса */}
                    <div className="note-question-card">
                        <div className="note-question-image">
                            {coverUrl && <img src={coverUrl} alt="Обложка" />}
                        </div>
                        <div className="note-question-text">
                            <h3 className="note-question-title">{applyGender(card.question, getCachedGender())}</h3>
                            {card.subquestion && (
                                <p className="note-question-subtitle">{applyGender(card.subquestion, getCachedGender())}</p>
                            )}
                        </div>
                    </div>

                    {/* Карточка ввода */}
                    <div className="note-input-card">
                        <textarea
                            ref={textareaRef}
                            className="note-textarea"
                            placeholder="Все ваши заметки защищены шифрованием и доступны только вам"
                            value={noteText}
                            onChange={(e) => setNoteText(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
            </div>

            {/* Диалог подтверждения удаления черновика */}
            {showConfirmDialog && (
                <div className="confirm-dialog-overlay" style={{ zIndex: 3000 }}>
                    <div className="confirm-dialog">
                        <div className="confirm-dialog-content">
                            <h3 className="confirm-dialog-title">Удалить черновик заметки?</h3>
                            <p className="confirm-dialog-message">Ваш текст будет потерян</p>
                        </div>
                        <div className="confirm-dialog-buttons">
                            <button
                                className="confirm-dialog-btn confirm-dialog-btn--cancel"
                                onClick={handleCancelDelete}
                            >
                                Вернуться
                            </button>
                            <button
                                className="confirm-dialog-btn confirm-dialog-btn--delete"
                                onClick={handleConfirmDelete}
                            >
                                Удалить
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
